import { fetchAPI } from "helpers/fetchApi";

export async function fetchProfile() {
    return await fetchAPI("/ins/user/get_profile", "GET", {});
};
export async function fetchCartCount() {
    return await fetchAPI("/ins/cart/cartCount", "GET", {});
};